import {
  LOADING_AUTHOR,
  RECEIVED_AUTHOR,
  RECEIVED_AUTHOR_FAILED,
  OPEN_AUTHOR,
} from '../../actions/types';

export default function authors(state = { data: [] }, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case LOADING_AUTHOR: {
      const newData = [...state.data];
      newData[payload.index] = { isLoading: true };
      return {
        ...state,
        data: newData,
      };
    }
    case RECEIVED_AUTHOR: {
      const newData = [...state.data];
      newData[payload.index] = {
        isLoading: false,
        data: payload.data,
      };
      return {
        ...state,
        data: newData,
      };
    }
    case RECEIVED_AUTHOR_FAILED: {
      const newData = [...state.data];
      newData[payload.index] = {
        isLoading: false,
        failed: true,
      };
      return {
        ...state,
        data: newData,
      };
    }
    case OPEN_AUTHOR: {
      return {
        ...state,
        index: payload,
      };
    }
    default:
      return state;
  }
}
